/* Blok stillerinin CSS'i — design.css'e ekleniyor (tools/src/design.ts).

   Seçici `[data-bid="<kimlik>"]`: oluşturucu bu özniteliği yalnızca stilli
   bloklara basıyor (render.ts `hasCss`). Renk ve zemin sitenin
   değişkenlerini de eziyor (`--fg`, `--bg`), böylece bloğun içindeki
   bağlantı, kenarlık gibi değişkene bağlı parçalar da aynı rengi alıyor. */

import { FONTS, walk, type Block, type BlockStyle } from '@frawgraphy/shared';

const SPACE: Record<NonNullable<BlockStyle['padY']>, string> = {
  none: '0',
  s: 'var(--sp-4)',
  m: 'var(--sp-8)',
  l: 'var(--sp-16)',
  xl: 'var(--sp-24)'
};

export function blockCss(blocks: Block[]): string {
  const rules: string[] = [];
  walk(blocks, (b) => {
    const s = b.style;
    if (!s) return;
    const decls: string[] = [];
    if (s.color) decls.push(`--fg: ${s.color};`, `color: ${s.color};`);
    if (s.bg) decls.push(`--bg: ${s.bg};`, `--bg-elev: ${s.bg};`, `background-color: ${s.bg};`);
    if (s.scale && s.scale !== 1) decls.push(`font-size: calc(1em * ${s.scale});`);
    if (s.font) decls.push(`font-family: "${s.font}", ${FONTS[s.font].fallback};`, `--font-display: "${s.font}", ${FONTS[s.font].fallback};`);
    if (s.weight) decls.push(`font-weight: ${s.weight};`);
    if (s.padY) decls.push(`padding-block: ${SPACE[s.padY]};`);
    if (s.marginY) decls.push(`margin-block: ${SPACE[s.marginY]};`);
    if (decls.length) rules.push(`[data-bid="${b.id}"] {\n  ${decls.join('\n  ')}\n}`);
  });
  return rules.join('\n\n');
}
